import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LAZY_VIEW_ENTRY_COMPONENT } from '../lazy-view/lazy-view-entry-component.injection-token';
import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { FluentThemeProviderContentDirective } from './fluent-theme-provider-content.directive';
import { FluentThemeProviderComponent } from './fluent-theme-provider.component';

@NgModule({
    imports: [
        CommonModule,
        LazyViewModule
    ],
    declarations: [
        FluentThemeProviderComponent,
        FluentThemeProviderContentDirective
    ],
    providers: [
        { provide: LAZY_VIEW_ENTRY_COMPONENT, useValue: FluentThemeProviderComponent }
    ],
    entryComponents: [
        FluentThemeProviderComponent
    ]
})
export class FluentThemeProviderModule {
}
